import React, { useEffect, useMemo, useRef, useState } from "react";
import { Button, Form, Row, Col, Typography, Space, message, Tooltip, Flex, Input, Select } from "antd";
import RichTextEditor from "./components/TextEditor/pages/RichTextEditor";
import { trimStringValues } from "../../../utils/trimStrings";
import {
  $createParagraphNode,
  $createTextNode,
  $getRoot,
  $getSelection,
  $insertNodes,
  COMMAND_PRIORITY_LOW,
  COMMAND_PRIORITY_HIGH,
  FOCUS_COMMAND,
  LexicalEditor,
} from "lexical";
import { $generateHtmlFromNodes, $generateNodesFromDOM } from "@lexical/html";
import { LexicalComposer } from "@lexical/react/LexicalComposer";
import { initialConfig } from "./components/TextEditor/constants";
import EditEmailContent from "./components/editEmailContent";
import { useLoaderData, useSearchParams } from "react-router-dom";
import { useTenantNavigation } from "../../../hooks/useTenantNavigation.js";
import axios from "../../../axios-interceptor.js";
import { useParams } from "react-router-dom";

import { notificationItems } from "../list";
import { AlignLeftOutlined, ArrowLeftOutlined, CalendarOutlined, CheckSquareOutlined, EditOutlined, FileImageOutlined, FontSizeOutlined, HomeOutlined, LeftOutlined, LinkOutlined, MailTwoTone, PaperClipOutlined, ProfileOutlined, QuestionCircleFilled, QuestionCircleOutlined, TableOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { blue } from "@ant-design/colors";
import BreadCrumb from "../../BreadCrumb";
import { useSelector } from "react-redux";
import { getUserSpaceEntitlements } from "../../../utils/currentUserDetail";
import { useTranslation } from "react-i18next";
import PublicationNotificationRule from "./components/publicationNotificationRule";
import { useAppSelector } from "../../../redux/hooks";
import { showLoader } from "../../../utils/showloader";
import { notificationEditData } from "../../../services/notificationServices";
import { getNotificationIdTemplate, getSpaceWorkflow } from "../../../services/WorkflowServices";
import { getSpaceAllFormsByWorkflowId } from "../../../services/requestServices";
import { getAllWidgets } from "../../../utils/formsHelper";
import { FORM_LANGUAGES, FORM_LANGUAGE_OPTIONS, DEFAULT_LANGUAGE, resolveFieldTranslation } from "../../../utils/formTranslations";


const container = {
  // backgroundColor: "#F5F5F5",
  paddingTop: "12px",
};

let tenantId = localStorage.getItem("tenantId")

// Built-in mention fields. `id` is the canonical value stored in the template
// (and the key the mail job substitutes on); `labelKey` is the i18n key used to
// display it, so the chip follows the selected template language.
const BUILT_IN_WIDGETS = [
  { id: "Space name", labelKey: "Space name" },
  { id: "Request Id", labelKey: "Request ID" },
  { id: "Recipient", labelKey: "Recipient" },
  { id: "Workflow step", labelKey: "Workflow step" },
  { id: "Current step", labelKey: "Current step" },
  { id: "Chatroom message sender", labelKey: "Chatroom message sender" },
  { id: "Chatroom message", labelKey: "Chatroom message" },
  { id: "Last updater", labelKey: "Last updater" },
  { id: "Last comment", labelKey: "Last comment" },
  { id: "Due date", labelKey: "Due date" },
  // { id: "Exported file name", labelKey: "Exported file name" },
  { id: "Requester", labelKey: "Requester" },
  // { id: "Payment Due Amount", labelKey: "Payment Due Amount" },
  // { id: "Payment Due Month", labelKey: "Payment Due Month" },
];

const notificationItemsMap = Object.keys(notificationItems).reduce(
  (acc, key) => {
    const { children } = notificationItems[key];

    for (const key in children) {
      acc[key] = children[key].title;
    }
    return acc;
  },
  {}
);

const EditEmail = () => {
  // const { notificationtype, subject, body } = useLoaderData();
  const [notificationtype, setNotificationtype] = useState(null)
  const [subject, setSubject] = useState("")
  const [body, setBody] = useState(null)
  const [form] = Form.useForm();
  const navigate = useTenantNavigation()
  const { spaceId, notificationId } = useParams();
  const [definedWidgets, setDefinedWidgets] = useState();
  const [orgStructureWidgets, setOrgStructureWidgets] = useState();
  const [rawWidgets, setRawWidgets] = useState([])
  const [enabled, setEnabled] = useState(false)
  const [notification, setNotification] = useState({})
  // Language currently being authored. The subject/body in the editors always
  // belong to `editLang`; every other language's draft waits in
  // `languageContentRef` until save.
  const [editLang, setEditLang] = useState(DEFAULT_LANGUAGE)
  const languageContentRef = useRef({})
  // Last language/content pair pushed into the editors, so a widget-metadata
  // re-run can be told apart from a real content change.
  const lastAppliedRef = useRef({ lang: null, subject: null, body: null })
  const editorRef =
    useRef(null);
  const subjectRef =
    useRef(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const { t, i18n } = useTranslation();
  // Bumped once a language bundle finishes loading so built-in field names
  // re-resolve instead of falling back to English.
  const [loadedLanguages, setLoadedLanguages] = useState(0);
  const { userInfo } = useSelector((state) => state.user)
  const currentSpaceData = userInfo.spaceInfo && userInfo.spaceInfo.find((space) => space.spaceId === spaceId)
  const spaceEntitlements = getUserSpaceEntitlements(spaceId, userInfo.userAccess)

  let notificationType = searchParams.get("type");
  let currentEditEntitlement = 'Notifications_GlobalEmails_Update';
  if (notificationType === 'workflow') {
    currentEditEntitlement = 'Notifications_WorkflowEmails_Update'
  } else if (notificationType === "rules") {
    currentEditEntitlement = "Notifications_NotificationRuleEmails_Update"
  }
  // const [currentSelected, setCurrentSelected] = useState <
  //   "EDITOR" | "SUBJECT" | null
  //   > (null);

  const [currentSelected, setCurrentSelected] = useState(null)
  const [isSubjectActive, setIsSubjectActive] = useState(false)
  const [subjectError, setSubjectError] = useState("")

  const findMatch = (data, key, value, parentKey) => {
    let result = []
    data.map((r) => {
      if (r[key] == value) {
        result.push({ ...r, parentKey: parentKey })
      }
      if (r.children) {
        result.push(...findMatch(r.children, key, value, r.label))
      }
    })
    return result
  }

  useEffect(() => {
    // Keep the fields in their untranslated form; `widgetItems` below derives
    // the labels for whichever template language is being authored.
    let defaultWidgets = BUILT_IN_WIDGETS.map((widget) => ({ ...widget, builtIn: true }))
    try {
      getSpaceWorkflow(spaceId).then((res) => {
        let workflowId = res?.data?.workflowId ?? ''
        getSpaceAllFormsByWorkflowId(workflowId).then((flow) => {
          let widgetList = []
          flow?.data?.forEach((item) => {
            let tempList = getAllWidgets(item.items)
            widgetList = [...widgetList, ...tempList]
          })
          widgetList = widgetList.map((item, indx) => {
            return {
              ...item,
              label: item.label || item.name || `Widget ${indx + 1}`
            }
          })
          setRawWidgets([...defaultWidgets, ...widgetList])
        })

      }).catch((e) => {

      })
    } catch (e) {

    }
  }, [])

  // i18next only holds the bundles it has fetched. Pull in the one for the
  // selected template language so built-in field names do not silently fall
  // back to English.
  useEffect(() => {
    if (i18n.hasResourceBundle?.(editLang, "translation")) return;
    let cancelled = false;
    Promise.resolve(i18n.loadLanguages(editLang))
      .then(() => {
        if (!cancelled) setLoadedLanguages((count) => count + 1);
      })
      .catch(() => { });
    return () => { cancelled = true; };
  }, [editLang, i18n]);

  // Field labels shown in the editors and the "Form Field" dropdowns, resolved
  // for the template language being authored. `id` stays canonical throughout.
  const widgetItems = useMemo(() => {
    const translate = i18n.getFixedT(editLang);
    const translateDefault = i18n.getFixedT(DEFAULT_LANGUAGE);

    return rawWidgets.map((widget, indx) => {
      const fallback = widget.label || widget.name || `Widget ${indx + 1}`;
      let label = fallback;
      let canonicalLabel = fallback;

      if (widget.builtIn) {
        label = translate(widget.labelKey);
        canonicalLabel = translateDefault(widget.labelKey);
      } else if (widget.translations) {
        label = resolveFieldTranslation(widget, editLang)?.label || fallback;
      }

      return {
        ...widget,
        key: widget.id,
        label: label || fallback,
        canonicalLabel,
        value: label || fallback
      };
    });
    // `loadedLanguages` re-runs this once a newly fetched bundle is available.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rawWidgets, editLang, i18n, loadedLanguages]);

  // Canonical id of a mention, in the order the mail job and
  // `injectDataInTemplate` look for it.
  const readMentionId = (span) => {
    const dataAttr = span.getAttribute('data-lexical-beautiful-mention-data');
    if (dataAttr) {
      try {
        const parsed = JSON.parse(dataAttr);
        if (parsed?.id) return String(parsed.id);
      } catch (error) { }
    }
    const legacy = span.getAttribute('data-beautiful-mention');
    if (legacy) return legacy.replace(/^@/, '');
    const value = span.getAttribute('data-lexical-beautiful-mention-value');
    return value ? value.replace(/^@/, '') : '';
  };

  // Match a stored mention to a field. Templates saved earlier may hold the
  // English label instead of the id, so fall back to both label forms.
  const findWidget = (mention) => {
    if (!mention || !widgetItems.length) return null;
    return widgetItems.find((widget) => String(widget.id) === mention)
      || widgetItems.find((widget) => widget.canonicalLabel === mention)
      || widgetItems.find((widget) => widget.label === mention)
      || null;
  };

  // Point a mention span at `widget`, showing its label in the selected
  // language while keeping the canonical id in the data attribute — the only
  // one that survives Lexical's export/import round trip.
  const applyWidgetToMention = (span, widget) => {
    span.setAttribute('data-lexical-beautiful-mention', 'true');
    span.setAttribute('data-lexical-beautiful-mention-trigger', '@');
    span.setAttribute('data-lexical-beautiful-mention-value', widget.label);
    span.setAttribute('data-lexical-beautiful-mention-data', JSON.stringify({ id: widget.id }));
    span.setAttribute('data-beautiful-mention', `@${widget.id}`);
    span.setAttribute('class', 'highlighted');
    span.setAttribute('contenteditable', 'false');
    span.setAttribute('data-lexical-decorator', 'true');
    span.textContent = `@${widget.label}`;
  };

  useEffect(() => {
    const loadNotification = async () => {
      try {
        showLoader(true)
        const res = await getNotificationIdTemplate(notificationId, spaceId)
        if (res.status === 200 && res.data && res.data.length > 0) {
          let notificationData = res.data[0];
          const languageSpecific = notificationData?.languageSpecific ?? {}

          // Hold on to every saved language so switching the selector never
          // drops a translation that this session did not touch.
          languageContentRef.current = Object.keys(languageSpecific).reduce((acc, lng) => {
            acc[lng] = {
              subject: languageSpecific[lng]?.subject || "",
              body: languageSpecific[lng]?.body || ""
            }
            return acc
          }, {})

          let subjectData = languageContentRef.current[DEFAULT_LANGUAGE] ?? {}

          setEditLang(DEFAULT_LANGUAGE)
          setSubject(subjectData.subject || "")
          setBody(subjectData.body)
          setNotificationtype(notificationData.notificationType)
          setEnabled(notificationData.enabled)

          // Extract and add any missing widgets from the content of every
          // language — a mention can appear in a translation only.
          Object.values(languageContentRef.current).forEach((content) => {
            extractAndAddMissingWidgets(content.subject);
            extractAndAddMissingWidgets(content.body);
          })
          setNotification(notificationData)
        }
      } catch (e) {
      } finally {
        showLoader(false)
      }
    }
    
    loadNotification()
  }, [])


  useEffect(() => {
    // Add a small delay to ensure editors are initialized
    const timer = setTimeout(() => {
      editorRef.current?.registerCommand(
        FOCUS_COMMAND,
        () => {
          setCurrentSelected("EDITOR");
          return false;
        },
        COMMAND_PRIORITY_LOW
      );
      subjectRef.current?.registerCommand(
        FOCUS_COMMAND,
        () => {
          setCurrentSelected("SUBJECT");
          return false;
        },
        COMMAND_PRIORITY_HIGH // Higher priority for subject to prevent interference
      );
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const saveToBackend = async (languageSpecific) => {
    let postData = {}
    if(notificationId !== "new") {
      postData["notificationId"] = notificationId
    }
    if (notificationType === "alert") {
      const formValues = trimStringValues(form.getFieldsValue());
      postData["title"] = formValues.title || ""
      postData["description"] = formValues.description || ""
      postData["notificationType"] = notificationType
      postData["count"] = Number(formValues.count) || 0;
      postData["frequency"] = Number(formValues.frequency) || 0;
      postData["occurrence"] = formValues.occurrence
      postData["notificationCount"] = Number(formValues.notificationCount) || 0;
      postData["period"] = formValues.period
      postData["triggerDate"] = formValues.triggerDate
      postData["recipients"] = formValues.recipients
      postData["status"] = "active"
    }
    showLoader(true)
    try {
      await axios({
        method: notificationId !== "new" ? "PUT" : "POST",
        url: `${process.env.REACT_APP_BACKEND_API}/notification`,
        params: {
          spaceId: spaceId,
        },
        data: {
          ...postData,
          enabled: enabled,
          languageSpecific
        },
        headers: {
          "Content-Type": "application/json",
          userId: userInfo.userId,
          tenantId: tenantId
        },
      }).then(res => {
        if (res.status == 200) {
          message.success(t("Notification Template updated successfully"))
          // Navigate to the newly created/updated notification
          const newNotificationId = res.data?.notificationId || res.data?.id;
          if (notificationId === "new" && newNotificationId) {
            navigate(`/app/space/${spaceId}/notification-center/${newNotificationId}?type=alert&notificationType=${notificationType}`)
          }
        }
      })
    } catch (error) {
    }
    showLoader(false)
  };

  const notificationSubjectLanguageMapping = {
    "english": {
      "EMAIL_SENT_TO_COLLABORATORS": (
        `<p class="paragraph">
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Space name">@Space name</span>
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Request Id">@Request Id</span>
          </p>`
      ),
      "SUMMARY_FOR_EVERY_EVENT_OF_THE_DAY": (
        `<p class="paragraph">
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Space name">@Space name</span>
            You've got reminders today on the space
          </p>`
      ),
      "CHATROOM_NOTIFICATION": (
        `<p class="paragraph">
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Space name">@Space name</span>
            New message has arrived in chatroom in
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Request Id">@Request Id</span>
            by
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Chatroom message sender">@Chatroom message sender</span>
          </p>`
      ),
      "CHATROOM_EXPORT_NOTIFICATION": (
        `<p class="paragraph">
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Space name">@Space name</span>
            Your export
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Exported file name">@Exported file name</span>
            is ready
          </p>`
      ),
      "WORKFLOW_STEP_NOTIFICATION": (
        `<p class="paragraph">
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Space name">@Space name</span>
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Request Id">@Request Id</span>
            is currently at the workflow step
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Workflow step">@Workflow step</span>
          </p>`
      ),
      "WORKFLOW_STEP_REFUSAL": (
        `<p class="paragraph">
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Space name">@Space name</span>
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Request Id">@Request Id</span>
            has been rejected at the workflow step
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Workflow step">@Workflow step</span>
          </p>`
      ),
      "WORKFLOW_STEP_SENT_BACK": (
        `<p class="paragraph">
          <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Space name">@Space name</span>
          <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Request Id">@Request Id</span>
          has been rejected at the workflow step
          <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Workflow step">@Workflow step</span>
           by
          <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Last updater">@Last updater</span>
        </p>`
      ),
      "WORKFLOW_STEP_WAITING": (
        `<p class="paragraph">
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Space name">@Space name</span>
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Request Id">@Request Id</span>
            is waiting for your approval at the workflow step
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Workflow step">@Workflow step</span>
          </p>`
      ),
      "WORKFLOW_STEP_WAITING_WITH_DUE_DATE": (
        `<p class="paragraph">
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Space name">@Space name</span>
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Request Id">@Request Id</span>
            is waiting for your approval at the workflow step
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Workflow step">@Workflow step</span>
            (Approval required before <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Due date">@Due date</span>)
          </p>`
      ),
      "WORKFLOW_END_NOTIFICATION": (
        `<p class="paragraph">
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Space name">@Space name</span>
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Request Id">@Request Id</span>
            has been approved
          </p>`
      ),
      "STEP_DUE_DATE_NOTIFICATION": (
        `<p class="paragraph">
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Space name">@Space name</span>
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Request Id">@Request Id</span>
            is waiting for your approval at the workflow step
            <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Workflow step">@Workflow step</span>
            (Approval required before <span data-lexical-beautiful-mention="true" data-lexical-beautiful-mention-trigger="@" data-lexical-beautiful-mention-value="Due date">@Due date</span>)
          </p>`
      )
    }
  }

  // Empty the editor that owns the active Lexical update and leave the caret
  // in a valid empty paragraph.
  const resetEditorContent = () => {
    const root = $getRoot();
    root.clear();
    const paragraph = $createParagraphNode();
    root.append(paragraph);
    paragraph.select();
  };

  useEffect(() => {
    const _editorRef = editorRef.current;
    const _subjectRef = subjectRef.current;

    // Only process content if widgets are available
    if (!widgetItems || widgetItems.length === 0) {
      return;
    }

    let reqLangSubject = "", reqLangBody = "";
    reqLangBody = body
    reqLangSubject = subject

    // This effect also re-runs when `widgetItems` grows (mentions resolve to
    // their labels once the widget metadata lands). On such a re-run there is
    // nothing new to load, so an empty language must not wipe what the author
    // has typed in the meantime — only a real language/content change clears.
    const applied = lastAppliedRef.current;
    const isContentChange =
      applied.lang !== editLang ||
      applied.subject !== reqLangSubject ||
      applied.body !== reqLangBody;
    lastAppliedRef.current = { lang: editLang, subject: reqLangSubject, body: reqLangBody };

    // The editors are rebuilt from scratch on every language switch, so an
    // empty translation has to clear them rather than leave the previous
    // language's content behind.
    _editorRef?.update(() => {
      if (!reqLangBody) {
        if (isContentChange) resetEditorContent();
        return;
      }
      const root = $getRoot();
      root.select();
      root.clear();
      let processedBody = convertBracketTextToMentions(reqLangBody);
      const normalizedBody = normalizeMentionContent(processedBody);
      const domParse = new DOMParser();
      const parsedDom = domParse.parseFromString(normalizedBody, "text/html");
      const nodes = $generateNodesFromDOM(_editorRef, parsedDom);
      $insertNodes(nodes);
    });
    _subjectRef?.update(() => {
      const domParse = new DOMParser();
      let params = new URLSearchParams(window.location.href)
      let notificationtype = params.get("notificationType")
      const notificationMapping = notificationSubjectLanguageMapping[DEFAULT_LANGUAGE]

      // The seeded default subject is English copy, so only the default
      // language falls back to it; a translation starts empty.
      const subjectContent = reqLangSubject ||
        (editLang === DEFAULT_LANGUAGE ? notificationMapping[notificationtype] : "") || "";

      if (!subjectContent) {
        if (isContentChange) resetEditorContent();
        return;
      }

      let processedSubject = convertBracketTextToMentions(subjectContent);
      const normalizedSubject = normalizeMentionContent(processedSubject);

      const parsedDom = domParse.parseFromString(normalizedSubject, "text/html");

      const nodes = $generateNodesFromDOM(_subjectRef, parsedDom);
      $getRoot().select();
      $getRoot().clear();
      $insertNodes(nodes);
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subject, body, widgetItems, editLang]);

  // Put the canonical ids back in the mention value before storing. The
  // editors show translated labels there, but the stored template must stay
  // language independent — the mail job substitutes on that attribute.
  const canonicalizeMentions = (html) => {
    if (!html) return html;

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;

    const mentionSpans = tempDiv.querySelectorAll('span[data-lexical-beautiful-mention-value]');
    mentionSpans.forEach(span => {
      const mentionId = readMentionId(span);
      const widget = findWidget(mentionId);
      // Fall back to the id carried on the span when the field itself can no
      // longer be resolved, so an unknown mention is never stored under its
      // translated label.
      const canonicalId = widget ? String(widget.id) : mentionId;
      if (!canonicalId) return;
      span.setAttribute('data-lexical-beautiful-mention-value', canonicalId);
      span.setAttribute('data-lexical-beautiful-mention-data', JSON.stringify({ id: canonicalId }));
      span.setAttribute('data-beautiful-mention', `@${canonicalId}`);
      span.textContent = `@${canonicalId}`;
      span.removeAttribute('data-widget-uuid'); // legacy attribute, no longer used
    });

    return tempDiv.innerHTML;
  };

  const htmlToText = (html) => {
    if (!html) return "";
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent?.trim() || "";
  };

  // Read what is currently in the two editors as HTML.
  const readEditorsHtml = () => {
    const editor = editorRef.current;
    const subjectEditor = subjectRef.current;
    let subjectHtml = "", bodyHtml = "";

    editor?.update(() => {
      bodyHtml = $generateHtmlFromNodes(editor, null);
    });
    subjectEditor?.update(() => {
      subjectHtml = $generateHtmlFromNodes(subjectEditor, null);
    });

    // Drafts are kept canonical so switching language re-resolves every
    // mention into the new language's labels.
    return { subject: canonicalizeMentions(subjectHtml), body: canonicalizeMentions(bodyHtml) };
  };

  // Fold the editors' current content into the per-language drafts and return
  // the complete map.
  const collectLanguageContent = () => {
    languageContentRef.current = {
      ...languageContentRef.current,
      [editLang]: readEditorsHtml()
    };
    return languageContentRef.current;
  };

  const onLanguageChange = (nextLang) => {
    if (nextLang === editLang) return;
    const allContent = collectLanguageContent();
    // A language with nothing saved yet starts from a copy of the default
    // language, so the author translates the text in place and keeps the
    // template's layout instead of rebuilding it.
    const nextContent = allContent[nextLang] ||
      (nextLang === DEFAULT_LANGUAGE ? null : allContent[DEFAULT_LANGUAGE]) ||
      { subject: "", body: "" };
    setSubjectError("");
    setEditLang(nextLang);
    setSubject(nextContent.subject || "");
    setBody(nextContent.body || "");
  };

  const onSave = async () => {
    const allContent = collectLanguageContent();

    let hasErrors = false;

    // Only the default language is mandatory — it is what every other
    // language falls back to.
    const defaultSubject = allContent[DEFAULT_LANGUAGE]?.subject;
    if (!htmlToText(defaultSubject)) {
      if (editLang !== DEFAULT_LANGUAGE) {
        // Send the author to the language that actually needs fixing, then
        // flag the error (the switch itself clears it).
        onLanguageChange(DEFAULT_LANGUAGE);
      }
      setSubjectError("Subject is required");
      hasErrors = true;
    } else {
      setSubjectError("");
    }

    // Validate form fields
    try {
      await form.validateFields();
    } catch (errorInfo) {
      hasErrors = true;
    }

    if (hasErrors) {
      return;
    }

    // Every supported language gets an entry, even an untranslated one, so the
    // payload always carries the full set:
    //   { english: {...}, japanese: { subject: "", body: "" }, ... }
    // Any language already stored but no longer in the supported list is kept
    // rather than silently dropped.
    const languageSpecific = {};
    const allLanguages = [
      ...FORM_LANGUAGES.map((lang) => lang.code),
      ...Object.keys(allContent)
    ];
    allLanguages.forEach((lng) => {
      if (languageSpecific[lng]) return;
      // `allContent` is already canonical — see readEditorsHtml.
      const content = allContent[lng] || { subject: "", body: "" };
      languageSpecific[lng] = {
        subject: content.subject || "",
        body: content.body || ""
      };
    });

    saveToBackend(languageSpecific);
  };

  const addWidget = (widgetName) => {
    if (!currentSelected) {
      return false;
    }
    let editor =
      currentSelected === "EDITOR"
        ? editorRef
        : currentSelected === "SUBJECT"
          ? subjectRef
          : null;
    editor?.current?.update(() => {
      const widget = $createTextNode(widgetName)
        .setMode("token")
        .setFormat("bold")
        .setStyle(
          "margin: 0px ;padding: 5px 10px ; font-weight: bold; background: rgba(230, 244, 255, 1); color : rgba(22, 119, 255, 1); display: inline;"
        );
      const selection = $getSelection();
      selection?.insertNodes([widget]);
    });
  };

  // Function to normalize mention data in HTML content
  const normalizeMentionContent = (htmlContent) => {
    if (!htmlContent || !widgetItems || widgetItems.length === 0) return htmlContent;


    // Create a temporary div to manipulate the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;

    // First, handle nested span structures - flatten them if they contain mentions
    const nestedSpans = tempDiv.querySelectorAll('span[data-lexical-decorator] span.highlighted');
    nestedSpans.forEach(innerSpan => {
      const outerSpan = innerSpan.closest('span[data-lexical-decorator]');
      if (outerSpan && outerSpan !== innerSpan) {
        // Copy inner span attributes to outer span
        const mentionValue = innerSpan.getAttribute('data-beautiful-mention');
        if (mentionValue) {
          outerSpan.setAttribute('data-beautiful-mention', mentionValue);
          outerSpan.setAttribute('class', 'highlighted');
          // Replace outer span content with just the inner span content
          outerSpan.innerHTML = innerSpan.innerHTML;
        }
      }
    });

    // Find all potential mention spans
    const allSpans = tempDiv.querySelectorAll('span');

    allSpans.forEach(span => {
      // Already a proper mention: re-point it at the field so the chip shows
      // the label for the template language currently being authored.
      if (span.hasAttribute('data-lexical-beautiful-mention') && span.hasAttribute('data-lexical-beautiful-mention-value')) {
        const matchingWidget = findWidget(readMentionId(span));
        if (matchingWidget) {
          applyWidgetToMention(span, matchingWidget);
        }
        return;
      }

      // Check if this span needs to be converted to a mention
      const displayText = span.textContent || span.innerText;
      const hasDataAttribute = span.hasAttribute('data-beautiful-mention') || span.hasAttribute('data-lexical-beautiful-mention-value');
      const isHighlighted = span.classList.contains('highlighted');
      const hasBracketText = displayText && displayText.match(/^\[.*\]$/);
      const hasMentionText = displayText && displayText.match(/^@.+$/);

      if (hasDataAttribute || isHighlighted || hasBracketText || hasMentionText) {
        // Extract the potential widget name
        let widgetName = null;
        let widgetId = null;

        // Try to get from attributes first
        if (span.hasAttribute('data-beautiful-mention')) {
          widgetId = span.getAttribute('data-beautiful-mention').replace(/^@/, '');
        } else if (span.hasAttribute('data-lexical-beautiful-mention-value')) {
          widgetId = span.getAttribute('data-lexical-beautiful-mention-value').replace(/^@/, '');
        }

        // If no attribute, try to extract from display text
        if (!widgetId && (hasBracketText || hasMentionText)) {
          widgetName = displayText.replace(/^\[|\]$|^@/g, '');
        }

        // Find the matching widget
        const matchingWidget = findWidget(widgetId || widgetName);

        if (matchingWidget) {
          applyWidgetToMention(span, matchingWidget);
        }
      }
    });

    const finalHTML = tempDiv.innerHTML;

    return finalHTML;
  };

  // Function to extract widget names from HTML content and add them to widget list
  const extractAndAddMissingWidgets = (htmlContent) => {
    if (!htmlContent) return;

    const isUuidLike = (value) => value && value.includes('-') && value.length > 30;

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;

    // Find all mention spans
    const allMentionSpans = tempDiv.querySelectorAll('span[data-lexical-beautiful-mention-value], span[data-beautiful-mention]');
    const discoveredWidgets = new Set();

    allMentionSpans.forEach(span => {
      const mentionValue = span.getAttribute('data-lexical-beautiful-mention-value') ||
        span.getAttribute('data-beautiful-mention');
      const normalizedMentionValue = mentionValue ? mentionValue.replace(/^@/, '') : '';
      const displayText = span.textContent || span.innerText;
      if (normalizedMentionValue) {
        discoveredWidgets.add(normalizedMentionValue);
      }

      // Also try to extract from display text
      if (displayText) {
        const extractedName = displayText.replace(/^\[|\]$|^@/g, '');
        if (extractedName && extractedName !== normalizedMentionValue) {
          discoveredWidgets.add(extractedName);
        }
      }
    });

    // Add discovered widgets to the widget list if they don't already exist.
    // They carry no translations, so the same label shows in every language.
    setRawWidgets(prev => {
      const known = new Set();
      prev.forEach(widget => {
        known.add(String(widget.id));
        if (widget.label) known.add(widget.label);
        if (widget.labelKey) known.add(widget.labelKey);
      });

      const newWidgets = [];
      discoveredWidgets.forEach(widgetName => {
        // Skip temporary UUID placeholders. Keep unresolved UUID mentions as [Loading...]
        // until widget metadata response arrives and provides the real field label.
        if (isUuidLike(widgetName)) {
          return;
        }
        if (!known.has(widgetName)) {
          known.add(widgetName);
          newWidgets.push({ label: widgetName, id: widgetName });
        }
      });

      return newWidgets.length > 0 ? [...prev, ...newWidgets] : prev;
    });
  };

  // Function to convert bracket text to mentions
  const convertBracketTextToMentions = (htmlContent) => {
    if (!htmlContent || !widgetItems || widgetItems.length === 0) return htmlContent;

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlContent;

    // Find text nodes containing [text] pattern
    const walker = document.createTreeWalker(
      tempDiv,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );

    const textNodes = [];
    let node;
    while ((node = walker.nextNode()) !== null) {
      if (node.nodeValue && node.nodeValue.includes('[') && node.nodeValue.includes(']')) {
        textNodes.push(node);
      }
    }

    textNodes.forEach(textNode => {
      const text = textNode.nodeValue;
      const bracketRegex = /\[([^\]]+)\]/g;
      let match;
      let lastIndex = 0;
      const fragments = [];

      while ((match = bracketRegex.exec(text)) !== null) {
        const beforeText = text.substring(lastIndex, match.index);
        const bracketText = match[1];

        if (beforeText) {
          fragments.push(document.createTextNode(beforeText));
        }

        // Find matching widget
        const matchingWidget = findWidget(bracketText);

        if (matchingWidget) {
          // Create a mention span
          const mentionSpan = document.createElement('span');
          applyWidgetToMention(mentionSpan, matchingWidget);

          fragments.push(mentionSpan);
        } else {
          // Keep as plain text if not a known widget
          fragments.push(document.createTextNode(`[${bracketText}]`));
        }

        lastIndex = bracketRegex.lastIndex;
      }

      // Add remaining text
      if (lastIndex < text.length) {
        fragments.push(document.createTextNode(text.substring(lastIndex)));
      }

      // Replace the text node with fragments
      if (fragments.length > 0) {
        const parent = textNode.parentNode;
        fragments.forEach(fragment => parent.insertBefore(fragment, textNode));
        parent.removeChild(textNode);
      }
    });

    return tempDiv.innerHTML;
  };

  return (
    <div className="page-wrapper">
      <Flex justify="space-between">
        <BreadCrumb
          items={[
            {
              title: <HomeOutlined />,
              path: userInfo.isAdmin ? "/app/dashboard" : "/app/dashboard",
            },
            {
              title: currentSpaceData?.name,
              path: `/app/space/${spaceId}/documents`
            },
            {
              title: t("Notification Center"),
              path: `/app/space/${spaceId}/notification-center?tab=${notificationType === "alert" ? "notification-rule" : notificationType}-emails`
            },
            {
              title: notificationId === "new" ? t("New") : (notification?.title || t(notificationItemsMap[notificationtype]) || "New"),
            }
          ]}
          marginb="24px"
        />
        <Space>
          {/* Labelled so it is not mistaken for the app-wide language picker
              in the top navigation. */}
          <Typography.Text type="secondary">{t("Template language")}</Typography.Text>
          <Select
            value={editLang}
            onChange={onLanguageChange}
            options={FORM_LANGUAGE_OPTIONS}
            style={{ minWidth: 220 }}
          />
          <Button style={{ background: '#50A248', color: "#FFFFFF" }} onClick={onSave} >{t("Save Changes")}</Button>
        </Space>
      </Flex>
      <div style={{ background: 'white', padding: '20px', borderRadius: '16px' }}>
        <Form form={form} layout="vertical">
          {editLang !== DEFAULT_LANGUAGE && (
            <div className="text-color-secondary" style={{ marginBottom: 16, fontSize: 12 }}>
              {t("Editing translation — only the subject and body are saved for this language. Other settings are shared across languages.")}
              <br />
              {t("An untranslated language starts as a copy of the default template.")}
            </div>
          )}
          {
            notificationType === "alert" ? 
            <>
            <Form.Item name="title" rules={[{ required: true, whitespace: true, message: t('Notification title is required') }]} label={t("Notification Name")}>
              <Input placeholder={t("Enter notification title")}/>
            </Form.Item>
            <Form.Item name="description" label={t("Notification Description")}>
              <Input placeholder={t("Enter notification description")}/>
            </Form.Item>
            </>
            
            : null
          }
          <EditEmailContent
            widgetItems={widgetItems}
            setCurrentSelected={setCurrentSelected}
            addWidget={addWidget}
            orgStructureWidgets={orgStructureWidgets}
            definedWidgets={definedWidgets}
            subjectRef={subjectRef}
            subjectValue={subject}
            onSubjectChange={setSubject}
            subjectError={subjectError}
          />

          {
            notificationType === "alert" && <PublicationNotificationRule notification={notification} key={notificationType} form={form} notificationType={notificationtype} setCurrentSelected={setCurrentSelected} addWidget={addWidget} orgStructureWidgets={orgStructureWidgets} definedWidgets={widgetItems} />
          }
          <Row style={container} gutter={8}>
            <Col span={24}>
              <LexicalComposer
                initialConfig={{
                  ...initialConfig,
                  editable: true,
                  // Don't auto-focus the editor on initialization
                  autoFocus: false,
                }}
              >
                <Form.Item
                  label={<div style={{ textAlign: 'left' }}>{t("Body")}<br /></div>}
                  name="message"
                  required
                >
                  <RichTextEditor
                    widgetItems={widgetItems}
                    editorRef={editorRef}
                    orgStructureWidgets={orgStructureWidgets}
                    definedWidgets={definedWidgets}
                    setCurrentSelected={setCurrentSelected}
                  />
                </Form.Item>
              </LexicalComposer>
            </Col>
          </Row>
        </Form>
      </div>
    </div>
  );
};

export default EditEmail;
